import moment from 'moment'
import 'moment/locale/es'

export const DBOARD_MINDATE = moment(process.env.REACT_APP_DATE_MIN).toDate()
export const DBOARD_FORMATSTART = 'YYYY-MM-DD 00:00:00'
export const DBOARD_FORMATEND = 'YYYY-MM-DD 23:59:59'
export const DBOARD_FORMATSMALL = 'DD-MM-YYYY'
